import { useMemo } from 'react';
import { MODULE_SIDEBAR_PRIMARY_IDS } from '@/ability';

/**
 * Splits visible module sidebar items into the primary strip (Roles, Home, Projects, Chat, Billing, HR)
 * and everything else for the "More" grid.
 */
export function useModuleSidebarSplit(visibleModules) {
    return useMemo(() => {
        const primaryIdSet = new Set(MODULE_SIDEBAR_PRIMARY_IDS);
        const primary = [];
        for (const id of MODULE_SIDEBAR_PRIMARY_IDS) {
            const m = visibleModules.find((x) => x.id === id);
            if (m) primary.push(m);
        }
        const more = visibleModules.filter((m) => !primaryIdSet.has(m.id));
        return { primaryModuleItems: primary, moreModuleItems: more };
    }, [visibleModules]);
}
